import { ModuleWithProviders, NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { NgxsStoragePluginModule, StorageOption } from '@ngxs/storage-plugin';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';

import { CorePublicState } from 'src/app/_core/stores/public/core-public.state';
import { environment } from 'src/environments/environment';

@NgModule({
    imports: [
        NgxsModule.forRoot([
            CorePublicState
        ], {developmentMode: !environment.production}),
        NgxsStoragePluginModule.forRoot({keys: '*', storage: StorageOption.SessionStorage}),
        NgxsReduxDevtoolsPluginModule.forRoot(),
    ]
})
export class StateManagementModule {
    static forRoot(): ModuleWithProviders<StateManagementModule> {
        return {
            ngModule: StateManagementModule
        };
    }
}
